import { queryClient } from "../queryClient";
import { store } from "../store";
import { clearCurrentUserSlice } from "../store/currentUser/slice";
import { clearMessageSlice } from "../store/message/slice";
import { clearAllDataDoctor } from "../store/doctor/slice";
import { clearTwilioSlice } from "../store/twilio/slice";
const AUTH_STORAGE_KEYS = [
  "access_token",
  "refresh_token",
  "user_uuid",
  "uuid_user",
  "is_refresh",
];

export const getAuthScope = () =>
  window.localStorage.getItem("user_uuid") ||
  window.localStorage.getItem("uuid_user") ||
  null;

export const hasAuthenticatedSession = () =>
  !!window.localStorage.getItem("access_token") && !!getAuthScope();

export function endSession({ clearTokens = true } = {}) {
  queryClient.cancelQueries();
  queryClient.clear();

  const twilioClient = store.getState().twilio?.client;
  if (twilioClient) {
    try {
      twilioClient.removeAllListeners?.();
      const shutdown = twilioClient.shutdown?.();
      shutdown?.catch?.(() => {});
    } catch {}
  }

  store.dispatch(clearCurrentUserSlice());
  store.dispatch(clearMessageSlice());
  store.dispatch(clearAllDataDoctor());
  store.dispatch(clearTwilioSlice());

  try {
    Array.from(
      { length: window.sessionStorage.length },
      (_, index) => window.sessionStorage.key(index),
    )
      .filter(Boolean)
      .filter((key) => key.startsWith("persist-emr-discharge:"))
      .forEach((key) => window.sessionStorage.removeItem(key));
    window.sessionStorage.setItem(
      "auth_generation",
      String(Date.now()),
    );
  } catch {}

  if (clearTokens) {
    AUTH_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key));
  }
}

export { AUTH_STORAGE_KEYS };
